import * as putil from '@bingads-webui-universal/primitive-utilities';
import { DateRangesFactory } from './src/date-ranges-factory';

const factory = new DateRangesFactory(putil);

export const getDateRanges = factory.makePrimaryDateRangesAccessor();
export const getComparedDateRanges = factory.makeComparedDateRangesAccessor();
export * from './src/constants';
